import { useMemo } from 'react';

import useForm from '../utils/useForm';
import downloadDocument from '../../helpers/downloadDocument';

const usePayoffLetterForm = (onSubmit, values) => {
  const fields = useMemo(
    () => [
      {
        title: 'Payoff Letter',
        fields: [
          {
            title: 'Payoff date',
            name: 'payoff_date',
            type: 'date',
            required: true,
          },
          {
            title: 'Email - Title Contact',
            name: 'email_title_contact',
            type: 'text',
            validation: 'email',
          },
          {
            title: 'Expiration date',
            type: 'date',
            name: 'expiration_date',
            onReadOnlyClick: () => {
              downloadDocument(values.document_id, 'payoff_letter.pdf');
            },
            readOnly: true,
            isHidden: () => !values,
          },
          {
            title: 'Lien Holder Name',
            name: '_lien_holder.name',
            isHidden: () => {
              return !values._lien_holder?.name;
            },
            type: 'text',
            readOnly: true,
          },
          {
            title: 'Lien Holder Payoff Amount',
            name: 'lien_holder_payoff_amount',
            type: 'currency',
            isHidden: () => {
              return !values._lien_holder;
            },
          },
          {
            title: 'Lien Holder Per Diem Interest',
            name: 'lien_holder_per_diem_interest',
            type: 'currency',
            isHidden: () => {
              return !values._lien_holder;
            },
          },
        ],
      },
    ],
    [values]
  );

  return useForm({ fields, onSubmit, values });
};

export default usePayoffLetterForm;
